import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-down-arrow',
    templateUrl: './down-arrow.component.html',
    styleUrls: ['./down-arrow.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownArrowComponent {}
